'use client';
import { IconPause, IconPlay } from 'components/ui/icons/player';
import { BtnNextTrack } from './btn-next-track';
import { BtnPrevTrack } from './btn-prev-track';
import { useSound } from 'hooks';
import styles from './control-track.module.scss';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../../store/hooks';
import { getPlayer } from '../../../../../store/slices/player.slices';
import { liveBroadcast } from '../../../../../libs/constants/live-broadcast';
import { clsx } from 'clsx';

export const ControlTrack = () => {
  /* Хук создает аудио дорожку и осуществляет
   * манипуляции с остановкой произведения
   * переключением трека и прокруткой по времени */
  const [hiddenControlTrack, setHiddenControlTrack] = useState(true);
  const { play, pause, isPlay } = useSound();
  const { track } = useAppSelector(getPlayer);
  const isTrackUrl = track.url === liveBroadcast[0].media.audio.url;

  /* Включает/выключает плеер */
  const onPlay = () => {
    if (!isPlay) {
      play();
    } else {
      pause();
    }
  };

  useEffect(() => {
    if (isTrackUrl) {
      setHiddenControlTrack(true);
    } else {
      setHiddenControlTrack(false);
    }
  }, [track.url]);

  useEffect(() => {
    if (!isPlay) {
      if (isTrackUrl) {
        ym(52577989, 'reachGoal', 'radiozvezda_pause');
      }
      pause();
    } else {
      if (isTrackUrl) {
        ym(52577989, 'reachGoal', 'radiozvezda_play');
      }
      play();
    }
  }, [isPlay]);

  return (
    <article className={styles.control}>
      {!hiddenControlTrack && <BtnPrevTrack />} {/* Кнопка включить прошлый трек */}
      <button onClick={onPlay} className={clsx((styles.btn, styles.playButtons))}>
        {isPlay ? <IconPause /> : <IconPlay />} {/* Кнопка пуск/пауза трека */}
      </button>
      {!hiddenControlTrack && <BtnNextTrack />} {/* Кнопка включить следущий трек */}
    </article>
  );
};
